import { createContext, useContext } from "react";

// SitePay 폼 제출을 하위(CardPayment/CashPayment)에서 프로그래매틱하게 트리거하기 위한 컨텍스트.
// react-hook-form은 useFormContext로 register/watch/formState를 제공하지만, 컨테이너의
// onSubmit(현금결제 요청 등)까지는 노출하지 않으므로 별도 컨텍스트로 submit을 내려준다.
interface SitePayFormContextValue {
  submit: () => void; // 폼 검증 통과 시 제출 실행
}

export const SitePayFormContext = createContext<SitePayFormContextValue | null>(
  null
);

export const useSitePayForm = () => {
  const ctx = useContext(SitePayFormContext);
  if (!ctx) {
    throw new Error("useSitePayForm 은 SitePay 컨테이너 내부에서만 사용할 수 있습니다.");
  }
  return ctx;
};
